import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Image } from '@common/core/models';
import { BitfFileUploaderComponent } from '@common/libs/bitforce/core/components/ui/file-uploader/bitf-file-uploader.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'mpa-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FileUploaderComponent extends BitfFileUploaderComponent<Image> implements OnInit {
  constructor(public injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  trackByIndex(index: number): number {
    return index;
  }

  onDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.files, event.previousIndex, event.currentIndex);
    }
  }

  getImageUrl(file: any): string {
    if (file.isImage && file.fileObject) {
      return URL.createObjectURL(file.fileObject);
    }
    return '';
  }
}
